import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import { LyceoUser } from './models/lyceo-user.model';
import { ADMIN_ACCOUNT } from './models/lyceo-user.model.mock';
import { UserService } from './service/user/user.service';
import { UserServiceMock } from './service/user/user.service.mock';

export function providePresetUser(
  model: LyceoUser = ADMIN_ACCOUNT,
): Provider | EnvironmentProviders[] {
  return [
    provideEnvironmentInitializer(() => {
      const userService = inject(UserService);
      (userService as unknown as UserServiceMock).setUser.set(model);
    }),
  ];
}
